<template>
  <Swiper
    v-if="flag"
    ref="swiper"
    :tag="tag"
    :options="swiperOptions"
    @ready="ready"
  >
    <slot />
  </Swiper>
</template>

<script>
import Swiper from './Swiper'
export default {
  components: {
    Swiper
  },
  props: {
    slides: Array,
    tag: {
      type: String,
      default: 'div'
    },
    options: {
      type: Object,
      default: () => ({})
    },
    groupNum: {
      type: Number,
      default: 1
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      swiper: null,
      swiperOptions: {
        slidesPerView: this.groupNum,
        slidesPerGroup: this.groupNum,
        ...this.options
      }
    }
  },
  computed: {
    flag() {
      return this.slides ? this.slides.length : true
    }
  },
  methods: {
    ready($el) {
      this.swiper = $el
      this.$emit('ready', this.swiper)
    }
  }
}
</script>
